import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MsinMatTableComponent } from '../msin-mat-table/msin-mat-table.component';
import { SearchByComponent } from '../search-by-layer/search-by-layer.component';
import { County } from 'src/app/model/county';
import { Region } from '../../../model/region.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';

// services
import { DistrictComponent } from '../../common-components/district/district.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchLocationLayerComponent } from '../search-location-layer/search-location-layer.component';
import { RouteGuardService } from 'src/app/guards/route-guard.service';
import { NavigationComponent } from '../../navigation/navigation.component';
import { UtilityService } from 'src/app/service/utility.service';
import { RegionDropdownTwoWayComponent } from '../../common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { CountyDropdownTwoWayComponent } from '../../common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';

@Component({
    selector: 'app-search-schools',
    templateUrl: './search-schools.component.html',
    styleUrls: ['./search-schools.component.css']
})
export class SearchSchoolsComponent implements OnInit, AfterViewInit {
    @ViewChild(MsinMatTableComponent) child!: MsinMatTableComponent;
    @ViewChild(SearchByComponent) child2!: SearchByComponent;
    @ViewChild(DistrictComponent) child3!: DistrictComponent;
    @ViewChild(RegionDropdownTwoWayComponent) child4!: RegionDropdownTwoWayComponent;
    @ViewChild(CountyDropdownTwoWayComponent) child5!: CountyDropdownTwoWayComponent;
    @ViewChild(SearchLocationLayerComponent) child6!: SearchLocationLayerComponent;
    @Output() eventEmitterSchoolsCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterSchoolsRegioncode = new EventEmitter<Region[]>();
    @Output() eventEmitterSchoolsDistrictcode = new EventEmitter<SchoolDistrict[]>();

    buttonLocation: string = 'top';
    filterPlaceholder: string = 'Filter items below';
    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';

    iRouteLen: number = 0;
    sessionSearchCriteriaIndex: number = 0;

    strLastRoute = '';
    strLastSchool = '';
    userId: string = '';

    constructor(
        private dialog: MatDialog,
        public routeGuardService: RouteGuardService,
        private navigationObj: NavigationComponent,
        private utilityService: UtilityService
    ) {
        // get user token
        const userToken = localStorage.getItem('userToken');
        if (userToken) {
            let objUser = JSON.parse(userToken);
            console.log('School Search: Current user:');
            console.log(objUser.user);
            this.userId = objUser.user.ID;
        }
    }

    thisGUID = '';
    isLoadingResults = false;
    isLoadingRegions = true;
    isLoadingCounties = true;
    isLoadingDistricts = true;
    isRateLimitReached = false;
    searchFilter: any = [{}];
    counties: any = [{}];
    regions: any = [{}];
    districts: any = [{}];
    selectedCounties: any = [];
    selectedRegions: any = [];
    selectedDistricts: any = [];
    title = 'msinComponent1';
    bShowMultipleSearchError: boolean = false;
    iCallAfterViewOnce: number = 0;
    countiesNumArray: number[] = [];
    regionsNumArray: number[] = [];
    schoolDistrictsNumArray: number[] = [];
    iCurUserActivityID: number = 0;
    iRoutesLen: number = 0;
    dataSource = [{}];

    ngOnInit(): void {
        //this.isLoadingResults = true;
        ///this.entityToUpdate$ = this.myDataServices.entities$ || undefined;
        console.log('searchSchools iCallAfterViewOnce:');
        console.log(this.iCallAfterViewOnce);
    }

    ngAfterViewInit() {
        // console.log('searchSchools iCallAfterViewOnce:');
        // console.log(this.iCallAfterViewOnce);
        // if (this.iCallAfterViewOnce == 0) {
        //     setTimeout(() => {
        //         // give time for common component selects to load with data
        //         this.doLoadingAfterView();
        //         this.isLoadingResults = false;
        //         console.log('now running chosen emits');
        //         if (this.regionsNumArray) {
        //             console.log(this.regionsNumArray);
        //             this.child6.child2.emitSelect(this.regionsNumArray);
        //         }
        //         if (this.countiesNumArray) {
        //             console.log(this.countiesNumArray);
        //             this.child6.child3.emitSelect(this.countiesNumArray);
        //         }
        //         if (this.schoolDistrictsNumArray) {
        //             console.log(this.countiesNumArray);
        //             this.child6.child.emitSelect(this.schoolDistrictsNumArray);
        //         }
        //         console.log('chosen emits done');
        //     }, 4000);
        //     this.iCallAfterViewOnce = this.iCallAfterViewOnce + 1;
        // }
    }

    ngAfterViewChecked() {
        if (this.iCallAfterViewOnce == 0 && this.iRouteLen == 0) {
            this.iCallAfterViewOnce = this.iCallAfterViewOnce + 1;

            this.doLoadingAfterView();
        }
    }

    doLoadingAfterView() {
        try {
            // need to get the GUID here first of the current user!
            console.log('Search Schools checking timedOut setting in doLoadingAfterView():');

            // code removed here from old bu package service
        } catch (Err) {
            console.log('error caught loading in ngAfterViewInit: ' + Err);
        }
    }

    onIsLoadingResultsEvent(isLoading: any) {
        this.isLoadingResults = isLoading;
    }

    onRegionChangeEvent(regionSet: any) {
        // let regionId: number = regionSet['ID'];
        // let bRerunSearchWithNewRegion: boolean = true;
        // let addTheseRegions: number[] = [];
        // addTheseRegions.push(regionId);
        // if (this.child6.child2.selectedRegionIds) {
        //     this.child6.child2.selectedRegionIds.forEach((thisRegionId) => {
        //         if (regionId == thisRegionId) {
        //             bRerunSearchWithNewRegion = false;
        //         } else {
        //             addTheseRegions.push(thisRegionId);
        //         }
        //     });
        // }
        // if (bRerunSearchWithNewRegion) {
        //     console.log('now calling rerun search with new region:');
        //     console.log('current selected regions:');
        //     console.log(this.child6.child2.selectRegionIds);
        //     addTheseRegions.forEach((thisRegion) => {
        //         this.child6.child2.selectRegionIds.push(thisRegion);
        //         this.child6.child2.selectedRegionIds.push(thisRegion);
        //         this.child6.child2.select(thisRegion);
        //         console.log('added: ' + thisRegion);
        //     });
        //     console.log('now going to run separate onSearchParmLessEvent due to Region select with: ');
        //     console.log(this.child6.child2.selectedRegionIds);
        //     console.log(this.child6.child2.selectRegionIds);
        //     this.onSearchParmLessEvent(this.child6.child2.selectRegionIds);
        // } else {
        //     this.onSearchParmLessEvent(this.child6.child2.selectedRegionIds);
        // }
    }

    getJsonLocationValue(key: string, jsonData: string) {
        let i = jsonData.indexOf(key);
        let firstSubStr = jsonData.substring(i).replace('"', '');
        let j = firstSubStr.indexOf(':');
        let k = firstSubStr.indexOf(',', j + 1);
        if (k <= 0) {
            k = firstSubStr.length;
        }
        firstSubStr = firstSubStr.substring(j + 1, k).replace('\\', '');
        firstSubStr = firstSubStr.replace('}', '');
        return firstSubStr;
    }

    onSearchParmEvent(inSearchParm: any) {
        console.log('calling search event in search-schools');

        console.log(inSearchParm);

        //	this.routeGuardService.searchCriterias = inSearchParm; // now put latest searchCriterias into routeGuardService's searchCriterias
        //	this.routeGuardService.screenToLoad = "/school/search";

        if (this.isLoadingResults && this.bShowMultipleSearchError) {
            this.child2.myError = 'Canceled last attempt with a new attempt...';
        }

        // SET SEARCH CRITERIA PARAMS
        console.log('search schools layer onSearchParmEvent triggered with: ');
        console.log(inSearchParm);

        this.child.searchParm = inSearchParm;

        let bUseSameRoute: Boolean = false;
        let bCountysIsBlank: Boolean = false;
        let bRegionsIsBlank: Boolean = false;
        let bDistrictsIsBlank: Boolean = false;

        let countiesShell: County[] = [];
        this.child.chosenCounties = countiesShell;
        this.child6.child3.selectedCountyIds.forEach((x) => {
            let countyShell: County = new County();
            countyShell.ID = x;
            console.log('pushing county:');
            console.log(countyShell);
            this.child.chosenCounties.push(countyShell);
        });

        this.selectedCounties = this.child.chosenCounties;

        if (this.selectedCounties) {
            if (this.utilityService.fnGetActualLen(this.selectedCounties) == 0) {
                bCountysIsBlank = true;
                console.log('counties is blank');
            }
        } else {
            console.log('counties was undefined');
            bCountysIsBlank = true;
        }

        let refreshDistrictShell: SchoolDistrict[] = [];
        this.child.chosenSchoolDistricts = refreshDistrictShell;
        let districtShell: SchoolDistrict = new SchoolDistrict();

        // handle if user selected no districts at all, we have to search all districts then
        if (!this.child6?.child?.selectedSchoolDistrictIds) {
            this.child6?.child?.selectAll();
        }
        this.child6?.child?.selectedSchoolDistrictIds.forEach((x) => {
            districtShell = new SchoolDistrict();
            districtShell.ID = x;
            this.child?.chosenSchoolDistricts?.push(districtShell);
        });
        this.selectedDistricts = this.child?.chosenSchoolDistricts;
        if (this.selectedDistricts) {
            if (this.utilityService.fnGetActualLen(this.selectedDistricts) == 0) {
                bDistrictsIsBlank = true;
                console.log('districts is blank');
            }
        } else {
            console.log('districts was undefined');

            bDistrictsIsBlank = true;
        }
        if (this.selectedRegions) {
            console.log("search school's region:");
            console.log(this.selectedRegions);
            if (this.utilityService.fnGetActualLen(this.selectedRegions) == 0) {
                console.log('regions is blank');
                bRegionsIsBlank = true;
            } else {
                this.child.chosenRegions = this.selectedRegions;
                console.log('set chosenRegion for search in searchschools to:');
                console.log(this.selectedRegions);
            }
        } else {
            console.log('regions was undefined');
            bRegionsIsBlank = true;
        }

        // CHECK FOR BLANK ENTRIES
        /*if (
            ((this.routeGuardService.searchCriterias[0]?.schoolName === null || this.routeGuardService.searchCriterias[0]?.schoolName == '') &&
                (this.routeGuardService.searchCriterias[0]?.schoolAddress === null || this.routeGuardService.searchCriterias[0]?.schoolAddress == '') &&
                (this.routeGuardService.searchCriterias[0]?.cdsCode1 === null || this.routeGuardService.searchCriterias[0]?.cdsCode1 == '') &&
                (this.routeGuardService.searchCriterias[0]?.cdsCode2 === null || this.routeGuardService.searchCriterias[0]?.cdsCode2 == '') &&
                (this.routeGuardService.searchCriterias[0]?.cdsCode3 === null || this.routeGuardService.searchCriterias[0]?.cdsCode3 == '') &&
                (this.routeGuardService.searchCriterias[0]?.schoolCity === null || this.routeGuardService.searchCriterias[0]?.schoolCity == '')) ||
            (this.routeGuardService.searchCriterias[0]?.schoolName &&
                this.routeGuardService.searchCriterias[0]?.schoolName == '' &&
                this.routeGuardService.searchCriterias[0]?.schoolAddress &&
                this.routeGuardService.searchCriterias[0]?.schoolAddress == '' &&
                this.routeGuardService.searchCriterias[0]?.cdsCode1 &&
                this.routeGuardService.searchCriterias[0]?.cdsCode1 == '' &&
                this.routeGuardService.searchCriterias[0]?.cdsCode2 &&
                this.routeGuardService.searchCriterias[0]?.cdsCode2 == '' &&
                this.routeGuardService.searchCriterias[0]?.cdsCode3 &&
                this.routeGuardService.searchCriterias[0]?.cdsCode3 == '' &&
                this.routeGuardService.searchCriterias[0]?.schoolCity &&
                this.routeGuardService.searchCriterias[0]?.schoolCity == '')
        ) {
            if (bCountysIsBlank && bRegionsIsBlank && bDistrictsIsBlank && this.bShowMultipleSearchError) {
                console.log('recognized blank filters');
                this.child2.myError = 'Please input into one of the above fields.';
                return;
            }
        } else {
            this.child2.myError = '';
        }*/

        console.log('this.iCurUserActivityID was');
        console.log(this.iCurUserActivityID);

        let curActivityId: number = this.iCurUserActivityID;

        curActivityId = curActivityId + 1;

        setTimeout(() => {
            this.child.getSpecificSchools(true);
        }, 2000); // this needs to be called after each persist of nosql, to load fresh copy of the updated data!
        // Note: 4000 was too quick, so we set it to 8000

        this.bShowMultipleSearchError = true;
    }

    onSearchParmLessEvent(inRegions: number[]) {
        console.log('calling onSearchParmLessEvent');

        // this method only called if a region changed during editschool
        this.child.searchParm = null; // this.routeGuardService.searchCriterias;
        let bCountysIsBlank: Boolean = false;
        let bRegionsIsBlank: Boolean = false;
        let bDistrictsIsBlank: Boolean = false;

        this.selectedCounties = this.child.chosenCounties;

        if (this.selectedCounties) {
            if (this.utilityService.fnGetActualLen(this.selectedCounties) == 0) {
                bCountysIsBlank = true;
                console.log('counties is blank');
            }
        } else {
            console.log('counties was undefined');
            bCountysIsBlank = true;
        }

        this.selectedDistricts = this.child.chosenSchoolDistricts;

        if (this.selectedDistricts) {
            if (this.utilityService.fnGetActualLen(this.selectedDistricts) == 0) {
                bDistrictsIsBlank = true;
                console.log('districts is blank');
            }
        } else {
            console.log('districts was undefined');

            bDistrictsIsBlank = true;
        }
        console.log('selectedRegions will now be');
        this.selectedRegions = inRegions;
        console.log(this.selectedRegions);

        if (this.selectedRegions) {
            if (this.utilityService.fnGetActualLen(this.selectedRegions) == 0) {
                console.log('regions is blank');
                bRegionsIsBlank = true;
            } else {
                this.child.chosenRegions = this.selectedRegions;
            }
        } else {
            console.log('regions was undefined');
            bRegionsIsBlank = true;
        }
        /* console.log('previous search parm:');
        console.log(this.routeGuardService.searchCriterias);
        if (
            ((this.routeGuardService.searchCriterias[0]['schoolName'] === null || this.routeGuardService.searchCriterias[0]['schoolName'] == '') &&
                (this.routeGuardService.searchCriterias[0]['schoolAddress'] === null || this.routeGuardService.searchCriterias[0]['schoolAddress'] == '') &&
                (this.routeGuardService.searchCriterias[0]['cdsCode1'] === null || this.routeGuardService.searchCriterias[0]['cdsCode1'] == '') &&
                (this.routeGuardService.searchCriterias[0]['cdsCode2'] === null || this.routeGuardService.searchCriterias[0]['cdsCode2'] == '') &&
                (this.routeGuardService.searchCriterias[0]['cdsCode3'] === null || this.routeGuardService.searchCriterias[0]['cdsCode3'] == '') &&
                (this.routeGuardService.searchCriterias[0]['schoolCity'] === null || this.routeGuardService.searchCriterias[0]['schoolCity'] == '')) ||
            (this.routeGuardService.searchCriterias[0]['schoolName'] &&
                this.routeGuardService.searchCriterias[0]['schoolName'] == '' &&
                this.routeGuardService.searchCriterias[0]['schoolAddress'] &&
                this.routeGuardService.searchCriterias[0]['schoolAddress'] == '' &&
                this.routeGuardService.searchCriterias[0]['cdsCode1'] &&
                this.routeGuardService.searchCriterias[0]['cdsCode1'] == '' &&
                this.routeGuardService.searchCriterias[0]['cdsCode2'] &&
                this.routeGuardService.searchCriterias[0]['cdsCode2'] == '' &&
                this.routeGuardService.searchCriterias[0]['cdsCode3'] &&
                this.routeGuardService.searchCriterias[0]['cdsCode3'] == '' &&
                this.routeGuardService.searchCriterias[0]['schoolCity'] &&
                this.routeGuardService.searchCriterias[0]['schoolCity'] == '')
        ) {
            if (bCountysIsBlank && bRegionsIsBlank && bDistrictsIsBlank) {
                console.log('recognized blank filters');
                this.child2.myError = 'Please input into one of the above fields.';
                return;
            }
        } else {
            this.child2.myError = '';
        }*/

        this.child.getSpecificSchools(true);
    }

    onResetMe() {
        this.child6.fnResetLocations();
        this.child.fnReset();
    }

    searchParmEvent(inSearchParm: any) {
        console.log("called parent's searchParm():" + inSearchParm);
    }

    catchSearchError(err: any) {
        console.log('search schools caught error:' + err);

        this.child2.myError = 'No school results. Please check your input.';
        this.isLoadingResults = false;
    }

    countiesInputSelected(counties: any) {
        this.selectedCounties = counties;
    }

    regionsInputSelected(regions: any) {
        this.selectedRegions = regions;
    }

    districtsInputSelected(districts: any) {
        this.selectedDistricts = districts;
    }
}
